import { render, staticRenderFns } from "./SetFeedbackPic.vue?vue&type=template&id=1200b091&scoped=true"
import script from "./SetFeedbackPic.vue?vue&type=script&lang=js"
export * from "./SetFeedbackPic.vue?vue&type=script&lang=js"
import style0 from "./SetFeedbackPic.vue?vue&type=style&index=0&id=1200b091&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1200b091",
  null
  
)

export default component.exports